import Config from '@config';
import { createApi } from '@reduxjs/toolkit/query/react';

import { CACHE_EXPIRATION_TIME_REFERENCE_BOOK } from '@/features/constants';
import axiosBaseQuery from '@/utils/axiosBaseQuery';

import { MeteringPointDisconnectionReason } from './types';

export const meteringPointDisconnectionReasonsApi = createApi({
  reducerPath: 'meteringPointDisconnectionReasonsApi',
  baseQuery: axiosBaseQuery({
    baseUrl: `${Config.VITE_API_URL}/disconnection-reasons`,
  }),
  keepUnusedDataFor: CACHE_EXPIRATION_TIME_REFERENCE_BOOK,
  endpoints: builder => ({
    getMeteringPointDisconnectionReasons: builder.query<
      MeteringPointDisconnectionReason[],
      void
    >({
      query: () => ({
        url: '',
      }),
    }),
  }),
});

export const { useGetMeteringPointDisconnectionReasonsQuery } =
  meteringPointDisconnectionReasonsApi;
